import React, { useRef, useState } from "react";
import { PlayIcon } from "lucide-react";
import { useYouTubeTracking } from "../hooks/useYouTubeTracking";

// ─── Configuración ───────────────────────────────────────────────
// ID del video de YouTube. Si está vacío se muestra el póster.
export const VIDEO_URL = "Mkqe4DJRPdQ";
// ─────────────────────────────────────────────────────────────────

type VideoPlayerProps = {
  /** "embed" loads the lazy iframe directly; "poster" shows a light poster and loads the iframe on tap. */
  mode: "embed" | "poster";
};
export function VideoPlayer({
  mode
}: VideoPlayerProps) {
  const [loaded, setLoaded] = useState(mode === "embed");
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const origin = typeof window !== "undefined" ? encodeURIComponent(window.location.origin) : "";
  const embedUrl = VIDEO_URL ? `https://www.youtube-nocookie.com/embed/${VIDEO_URL}?rel=0&modestbranding=1&playsinline=1&controls=1&enablejsapi=1&origin=${origin}${mode === "poster" ? "&autoplay=1" : ""}` : "";
  const showIframe = Boolean(embedUrl) && loaded;
  useYouTubeTracking(iframeRef, showIframe);
  return <div className="relative aspect-video w-full overflow-hidden rounded-[3px] border border-gold/70 bg-surface" data-id="element-367" data-mp="2oiwd11d7ophz">
      {showIframe ? <iframe ref={iframeRef} src={embedUrl} title="Mensaje del equipo — Studio Web VIP" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowFullScreen className="absolute inset-0 h-full w-full" data-id="element-368" data-mp="2yfiwpmtsxaif" /> : <button type="button" onClick={() => embedUrl && setLoaded(true)} aria-label="Reproducir video: Mensaje del equipo · 90 segundos" className="group absolute inset-0 flex flex-col items-center justify-center gap-3 bg-surface focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" data-id="element-369" data-mp="2anbui71ea9b3">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-gold text-ink transition-transform duration-200 ease-out group-active:scale-[0.97]" data-id="element-370" data-mp="1exl6knj6uug9">
            <PlayIcon className="ml-0.5 h-5 w-5 fill-ink" aria-hidden="true" data-id="element-371" data-mp="1onwd8hu9bhqu" />
          </span>
          <span className="eyebrow" data-id="element-372" data-mp="1jpl469bsdb9o">Mira el video · 90 s</span>
        </button>}
    </div>;
}